import React from 'react';
import { useIntl } from 'react-intl';

import {
  TApplicationCategory,
  TApplicationAttribute,
  TApplicationProduct,
} from '@marketplace/api';

import { useEmbedMode } from '../../../../features';

import { Checkbox } from '@marketplace/ui-elements';

import { TApplicationFilter } from '../app-gallery-page.types';
import './style.scss';

export default function ApplicationFilter(props: TApplicationFilter) {
  const { formatMessage } = useIntl();
  const { isEmbeddedMode, embedSource } = useEmbedMode();

  return (
    <div className={props.loading ? 'marketplace-filter disabled' : 'marketplace-filter'}>
      <div className="marketplace-filter__categories">
        <h3 className="marketplace-filter__title">
          {formatMessage({ id: 'app_gallery_categories' })}
        </h3>
        <ul className="marketplace-filter__list" hidden={isEmbeddedMode}>
          {props.isCategoriesLoaded &&
            props.categories.map((category: TApplicationCategory) => (
              <li key={category.id}>
                <Checkbox
                  name="category"
                  value={category.id}
                  label={category.name}
                  fieldId={category.id}
                  onChange={(e) =>
                    props.onCategoriesChange(
                      e,
                      props.selectedCategories,
                      props.setSelectedCategories
                    )
                  }
                  checked={
                    props.selectedCategories?.indexOf(category.id) !== -1
                  }
                />
              </li>
              
            ))}
        </ul>
        <ul className="marketplace-filter__list" hidden={!isEmbeddedMode}>
          {props.isCategoriesLoaded && embedSource==="ehr" &&
            props.categories.map((category: TApplicationCategory) => (
              <li key={category.id}  hidden={category.type ==="PATIENT_CATEGORY"}>
                <Checkbox
                  name="category"
                  value={category.id}
                  label={category.name}
                  fieldId={category.id}
                  onChange={(e) =>
                    props.onCategoriesChange(
                      e,
                      props.selectedCategories,
                      props.setSelectedCategories
                    )
                  }
                  checked={
                    props.selectedCategories?.indexOf(category.id) !== -1
                  }
                />
              </li>
              
            ))}
        </ul>
        <ul className="marketplace-filter__list" hidden={!isEmbeddedMode}>
          {props.isCategoriesLoaded && embedSource==="nonehr"  &&
            props.categories.map((category: TApplicationCategory) => (
              <li key={category.id}  hidden={category.type ==="CATEGORY" }>
                <Checkbox
                  name="category"
                  value={category.id}
                  label={category.name}
                  fieldId={category.id}
                  onChange={(e) =>
                    props.onCategoriesChange(
                      e,
                      props.selectedCategories,
                      props.setSelectedCategories
                    )
                  }
                  checked={
                    props.selectedCategories?.indexOf(category.id) !== -1
                  }
                />
              </li>
              
            ))}
        </ul>
      </div>

      <div className="marketplace-filter__types" hidden={isEmbeddedMode}>
        <h3 className="marketplace-filter__title">
          {formatMessage({ id: 'app_gallery_types' })}
        </h3>
        <ul className="marketplace-filter__list">
          {props.isAppTypesLoaded &&
            props.appTypes?.map((type: TApplicationAttribute) => (
              <li key={type.id}>
                <Checkbox
                  name="types"
                  value={type.id}
                  label={type.name}
                  fieldId={type.id}
                  onChange={(e) =>
                    props.onCategoriesChange(
                      e,
                      props.selectedTypes,
                      props.setSelectedTypes
                    )
                  }
                  checked={props?.selectedTypes?.indexOf(type.id) !== -1}
                />
              </li>
            ))}
        </ul>
      </div>

      <div className="marketplace-filter__products" hidden={isEmbeddedMode}>
        <h3 className="marketplace-filter__title">
          {formatMessage({ id: 'app_gallery_products' })}
        </h3>
        <ul className="marketplace-filter__list">
          {props.isSolutionsLoaded &&
            props.solutions.map((product: TApplicationProduct) => (
              <li key={product.id}>
                <Checkbox
                  name="types"
                  value={product.id}
                  label={product.name}
                  fieldId={product.id}
                  onChange={(e) =>
                    props.onCategoriesChange(
                      e,
                      props.selectedProducts,
                      props.setSelectedProducts
                    )
                  }
                  checked={props.selectedProducts?.indexOf(product.id) !== -1}
                />
              </li>
            ))}
        </ul>
      </div>
      
      <div className="marketplace-filter__products" hidden={isEmbeddedMode}>
        <h3 className="marketplace-filter__title">
          {formatMessage({ id: 'app_gallery_facing' })}
        </h3>
        <ul  className="marketplace-filter__list">
          <li key="PROVIDER">
            <Checkbox name="PROVIDER" value="PROVIDER" fieldId="PROVIDER" label= {formatMessage({ id: 'app_gallery_provider' })} 
              onChange={ (e)=> props.onFacingChange(e,props.selectedFacing,props.setSelectedFacing) } 
              checked={ props.selectedFacing?.indexOf('PROVIDER') != -1 } />
          </li>
          <li key="PATIENT">
            <Checkbox name="PATIENT" value="PATIENT" fieldId="PATIENT" label= {formatMessage({ id: 'app_gallery_patient' })} 
              onChange={ (e)=> props.onFacingChange(e,props.selectedFacing,props.setSelectedFacing) }  
              checked={ props.selectedFacing?.indexOf('PATIENT') != -1 } />     
          </li>
        </ul>  
      </div>
    </div>
  );
}
